import React from "react";
import Header from './Header'
import Section1 from "./Section1";
import Section2 from "./Section2";
import Footer from "./Footer";




export default function Todo(){

    return(
        <>
           <strong>
               <Header
                    header={'VOCÊ CONSCIENTE'} 
                    mesege={'PARTICIPE DOS DESAFIOS DIARIOS'}
                />
            </strong> 
            <Section1 
                image1={'https://gestion.pe/resizer/Hf2EFSRs91BA9IACmxSF-7zwef8=/1200x900/smart/filters:format(jpeg):quality(75)/arc-anglerfish-arc2-prod-elcomercio.s3.amazonaws.com/public/B7ZXBOYZS5H3FM7SLUTKN5DFAA.jpg'}
            />
            <Section2 
                image2={'https://i.pinimg.com/564x/e3/c8/44/e3c8447ea41ae5970badaf02cc55a724.jpg'}
                image3={'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSom4U1NWsxHXoCOOiQKittksieQAkfmB51uPieM51UCF4og-wxb412KXsn9TGFN9WnRnU&usqp=CAU'}
                image4={'https://catracalivre.com.br/wp-content/uploads/2017/08/cartilha-caes-gatos_21.png'}
            />

           

            <Footer 
                footer={'Copyright ©2021 | '} 
                sema={' SEMA AJA |'}
                jaba={' Douglas S.'}
            />
        </>
    )

}